

import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {isNumber} from "util";

export class HarlequinSignHandler implements GameRoundPresentation {

    private _wildOverlayReels:boolean [] = [];
    private _hasWin:boolean = false;
    private _tl:Timeline;
    private _inFreespin:boolean;
    private _inWildRespinFS:boolean;
    private _freespinsLeft:number;
    private _repinTriggered:boolean;

    private _fromMode:string;
    private _toMode:string;


    constructor() {

    }

    public getAnimation(data: HarlequinParsedGameData):Timeline {
        const tl:TimelineLite = new TimelineLite();

        if(this._hasWin) {
            let numberLeft:number = 0;

            this._wildOverlayReels.forEach((evalVal:boolean, index:number) => {
                if(evalVal) {
                    numberLeft = index;
                }
            });

            tl.add([
                (this._inFreespin && this._fromMode === "WILD_RESPIN_FS" && this._toMode === "WILD_RESPIN_FS" && numberLeft > 0)? () =>  {
                    // TODO: Update sign
                    HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation((numberLeft <= 0)? -1 : numberLeft);
                } : () =>  {
                    if(!this._inFreespin && this._fromMode === "WILD_RESPIN" && this._toMode === "WILD_RESPIN" && numberLeft > 0) {
                        HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation((numberLeft <= 0)? -1 : numberLeft);
                        SlotGame.keypad.setZeroBetSpinCounter((numberLeft <= 0)? -1 : numberLeft);
                    }
                },
                //(this._inFreespin && numberLeft > 0)? () => SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft) : () => {},
               //(!this._repinTriggered && numberLeft === 0)? () => HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(numberLeft) : () => {}
            ], "+=.1.2");

        }
        else {
            //tl.add(() => { // TODO: Handled in respin outro
                //HarlequinGameModuleConfig.harlequinSignView.playTextSpine("HarlequinRespinTextBaseGame");
            //});
        }

        this._tl = tl;
        return this._tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        if(isActive && this._tl) {
            //GameRoundManager.detachAndPlayTimeline(this._tl);
            return this._tl;
        }
        else {
            if(this._hasWin) {
                this.getAnimation(data);
            }
        }
        return null;
    }

    public prepare(data: HarlequinParsedGameData): void {
        this._wildOverlayReels = data.wildOverlayReels || [false, false, false, false, false];
        this._hasWin = !(this._wildOverlayReels.every(((value) => { return !value; })));
        this._inFreespin = (data.mode === "FREESPIN" || data.mode === "WILD_RESPIN_FS")? true : false;
        this._repinTriggered = (data.mode === "NORMAL" || data.mode === "FREESPIN") && (data.nextMode === "WILD_RESPIN" || data.nextMode === "WILD_RESPIN_FS");
        this._inWildRespinFS = data.mode === "WILD_RESPIN_FS";
        this._fromMode = data.mode;
        this._toMode = data.nextMode;


        this._freespinsLeft = data.freespinsLeft;
    }

}